import clsx from 'clsx';
import { useRef } from 'react';
import styles from './Accordion.module.scss';
import Icon from '../Icon';
import Text from '../Text/Text';
import { useResize } from '@/hooks/useResize';

export interface IAccordion {
  title: string;
  description: string;
  toggleAccordion: () => void;
  isOpen: boolean;
  className?: string;
  iconStyle?: React.CSSProperties;
  isTransparent?: boolean;
  isFAQ?: boolean;
  biggerText?: boolean;
}

const BOTTOM_PADDING = 24;

const Accordion = ({
  title, description, toggleAccordion, isOpen, className, iconStyle, isTransparent, isFAQ, biggerText,
}: IAccordion) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const updateHeight = () => {
    const el = contentRef.current;
    if (!el) return;

    if (isOpen) {
      el.style.maxHeight = `${el.scrollHeight + BOTTOM_PADDING}px`;
      el.style.opacity = '1';
    } else {
      el.style.maxHeight = '0px';
      el.style.opacity = '0';
    }
  };

  useResize(updateHeight, [isOpen]);

  return (
    <div className={clsx(styles.accordion, className, { [styles.isTransparent]: isTransparent, [styles.isFAQ]: isFAQ })}>
      <header
        className={styles.accordion_header}
        onClick={toggleAccordion}
        role='presentation'
      >
        <Text
          tag='p'
          isBold
          className={clsx(styles.title, { [styles.biggerText]: biggerText })}
        >
          {title}
        </Text>
        <Icon
          style={{ fontSize: 24, ...iconStyle }}
          className={clsx(styles.arrow, { [styles.open]: isOpen })}
          name='keyboard_arrow_down'
        />
      </header>
      <div
        className={clsx(styles.accordion_content, {
          [styles.open]: isOpen,
        })}
        ref={contentRef}
      >
        <div
          className={clsx(styles.content, 'htmlEditorContent')}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
    </div>
  );
};

export default Accordion;
